const Support = () => {
  return (
    <div className="w-full lg:w-3/4 min-h-screen bg-gray-100 text-gray-900">
      <h1 className="text-4xl mb-4">Contact Support</h1>
      <p className="text-2xl">Have a Question or need help? We’re here: <a style={{ color: 'deepSkyBlue' }}href="mailto:support@jackathome.com">support@jackathome.com</a></p>
    </div>
  );
};

export default Support;
